<template>
  <div class="h-container">
    <div class="mx-auto mt-4 flex max-w-[800px] flex-col gap-6 rounded-2xl bg-background-light px-6 py-8 sm:px-8 sm:py-10" itemscope itemtype="https://schema.org/FAQPage">
      <div v-for="(faqItem, index) in props.items" :key="`faq-item-${index}`" itemprop="mainEntity" itemscope itemtype="https://schema.org/Question">
        <p itemprop="name" class="mb-2.5 text-subtitle font-medium">{{ faqItem.question }}</p>
        <div itemprop="acceptedAnswer" itemscope itemtype="https://schema.org/Answer" class="text">
          <div itemprop="text">
            <ul class="list -mb-2.5 marker:text-text-strong">
              <li v-for="(item, itemIndex) in faqItem.answerLinks" :key="`faq-item-${index}-link-${itemIndex}`">
                <NuxtLink :to="item.url">{{ item.name }}</NuxtLink>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
const props = defineProps<{
  items: {
    question: string
    answerLinks: {
      name: string
      url: string
    }[]
  }[]
}>()
</script>
